import type { FC } from 'react';

import type { ClassStyleProps } from '../../../../types/ClassStyleProps';

export const WalletConnectIcon: FC<ClassStyleProps> = ({
  className,
  style,
}) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g clipPath="url(#clip0_1815_6238)">
        <path
          d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
          fill="#4084ED"
        />
        <path
          d="M3.34318 4.28635C4.81029 2.82122 7.18971 2.82122 8.65682 4.28635L8.83325 4.4615C8.90753 4.53487 8.90753 4.65322 8.83325 4.72659L8.22969 5.33016C8.19255 5.36566 8.13451 5.36566 8.09737 5.33016L7.85362 5.08637C6.8299 4.06385 5.17011 4.06385 4.14638 5.08637L3.88638 5.34673C3.84924 5.38223 3.7912 5.38223 3.75406 5.34673L3.14818 4.74553C3.0739 4.67215 3.0739 4.55381 3.14818 4.48043L3.34318 4.28635ZM9.90573 5.53372L10.4443 6.07101C10.5186 6.14438 10.5186 6.26273 10.4443 6.3361L8.01844 8.75747C7.94416 8.83084 7.82577 8.83084 7.7538 8.75747L6.03366 7.03908C6.01509 7.02014 5.98491 7.02014 5.96634 7.03908L4.2462 8.75747C4.17191 8.83084 4.05352 8.83084 3.98156 8.75747L1.55571 6.3361C1.48143 6.26273 1.48143 6.14438 1.55571 6.07101L2.09427 5.53372C2.16856 5.46034 2.28695 5.46034 2.35891 5.53372L4.07906 7.2521C4.09763 7.27104 4.12781 7.27104 4.14638 7.2521L5.86652 5.53372C5.9408 5.46034 6.0592 5.46034 6.13116 5.53372L7.8513 7.2521C7.86987 7.27104 7.90005 7.27104 7.91862 7.2521L9.63877 5.53372C9.71305 5.46034 9.83144 5.46034 9.90573 5.53372Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1815_6238">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
